type SpedSupportLevel = "MILD" | "SEVERE";

type SpedSupportSetting = "CO_TEACHING" | "PUSH_IN" | "PULL_OUT" | "SDC";

export type SpedDetailsType = {
  supportLevel: Array<SpedSupportLevel>;
  setting: Array<SpedSupportSetting>;
  toileting?: boolean;
};

export const initialSpedDetailsState: SpedDetailsType = {
  supportLevel: [],
  setting: [],
  toileting: undefined,
};
